import { NgModule } from '@angular/core';

import { SharedModule } from '../shared';

import { LoginComponent } from './login/LoginComponent';
import { LogoutComponent } from './logout/LogoutComponent';

import { adminRouting } from './AdminRouting';

import { AdminService } from './services/AdminService';
import { SessionService } from './services/SessionService';

@NgModule({
    imports: [
        SharedModule,
        adminRouting,
    ],
    declarations: [
		LoginComponent,
        LogoutComponent
    ],
    providers: [
        AdminService,
        SessionService,
    ],
    exports: [
        LogoutComponent
    ]
})

export class AdminModule { }


// WEBPACK FOOTER //
// ./src/common/modules/admin/AdminModule.ts